// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ApplicationBusinessUnitWithRelationsSchema } from './ApplicationBusinessUnitRelationsSchema'
import type { ApplicationBusinessUnitWithRelations } from './ApplicationBusinessUnitRelationsSchema'
import { BusinessUnitSchema } from './BusinessUnitSchema';

/////////////////////////////////////////
// BUSINESS UNIT RELATION SCHEMA
/////////////////////////////////////////

export type BusinessUnitRelations = {
  applications: ApplicationBusinessUnitWithRelations[];
};

export type BusinessUnitWithRelations = z.infer<typeof BusinessUnitSchema> & BusinessUnitRelations

export const BusinessUnitWithRelationsSchema: z.ZodType<BusinessUnitWithRelations> = BusinessUnitSchema.merge(z.object({
  applications: z.lazy(() => ApplicationBusinessUnitWithRelationsSchema).array(),
}))